import Header from '../composant/Header';

import Grid from '../composant/Grid';
import Separator from '../composant/Separator';

import Footer from '../composant/Footer';

const Home = ({data}) => {
    return (
        <div>
            {data.map((val) => {
                switch(val.__component){
                    case 'sections.header':
                        return (<Header data={val}/>);
                    case 'sections.grid':
                        return (<Grid data={val}/>);
                    case 'sections.separator':
                        return (<Separator data={val}/>);
                    case 'sections.footer':
                        return (<Footer data={val}/>);
                    default:
                        return (<div>{val.__component}</div>);
                }
            })}
        </div>
    )
}

export default Home;